enum UserRole {
  ROBOT = 'robot',
  AXIONE_SUPPORT = 'axione support',
  EXTERN = 'extern'
}

export default UserRole;
